import cinempro from "../../../Assets/image/cinemapro.webp";
import doctor from "../../../Assets/image/Doctor.webp";
import ddcet from "../../../Assets/image/ddcet.webp";
import bizconnect from "../../../Assets/image/bizconnect.webp";

const products = [
  {
    id: 1,
    name: "CinemaPro",
    url: "/product/CinemaPro/1",
    img: cinempro,
    description:
      "CinemaPro is a premium platform designed to help film industry professionals manage their projects seamlessly, offering tools for collaboration, scheduling, and production tracking.",
    color: "bg-[#1D5B79]",
  },
  /* {
    id: 2,
    name: "MediCare Pro: Comprehensive Clinic Management System",
    url: "/product/MediCare Pro: Comprehensive Clinic Management System/2",
    img: doctor,
    description:
      "Doctor is a comprehensive clinic management platform that streamlines patient care, appointment scheduling, billing, and medical records management, improving the overall healthcare experience.",
    color: "bg-[#C8E6C9]",
  }, */
  {
    id: 3,
    name: "DDCET",
    url: "/product/DDCET/3",
    img: ddcet,
    description:
      "DDCET is a comprehensive, multi-tenant exam preparation platform designed for diploma students in Gujarat, India, offering bilingual study materials and real exam mock tests.",
    color: "bg-[#312E81]",
  },
  {
    id: 4,
    name: "BizConnect",
    url: "/product/BizConnect/4",
    img: bizconnect,
    description:
      "BizConnect is a comprehensive, multi-tenant e-commerce platform allowing merchants to set up storefronts, customize designs, and manage B2B/B2C retail and wholesale operations.",
    color: "bg-[#002D62]",
  },
];

export default products;
